<template>
    <div>
        <single-bar-chart
            :headerTitle="earned_value_per_period_based_on_calculation.headerTitle" 
            :chartSeries="earned_value_per_period_based_on_calculation.chartSeries"
            :chartxAxis="earned_value_per_period_based_on_calculation.chartxAxis"
            :chartLegend="earned_value_per_period_based_on_calculation.chartLegend"
            :chartColor="earned_value_per_period_based_on_calculation.chartColor"
            :chartLoaded="chartsLoaded"
        >
        </single-bar-chart>

        <single-bar-chart
            :headerTitle="earned_value_per_period_based_on_status.headerTitle" 
            :chartSeries="earned_value_per_period_based_on_status.chartSeries"
            :chartxAxis="earned_value_per_period_based_on_status.chartxAxis"
            :chartLegend="earned_value_per_period_based_on_status.chartLegend"
            :chartColor="earned_value_per_period_based_on_status.chartColor"
            :chartLoaded="chartsLoaded"
        >
        </single-bar-chart>

        <triple-bar-chart 
            :headerTitle="total_target_hours_vs_real_hours.headerTitle" 
            :headingSize="total_target_hours_vs_real_hours.headingSize"
            :chartSeries="total_target_hours_vs_real_hours.chartSeries"
            :chartxAxis="total_target_hours_vs_real_hours.chartxAxis"
            :chartLegend="total_target_hours_vs_real_hours.chartLegend"
            :chartLoaded="chartsLoaded"
        >
        </triple-bar-chart>

        <line-chart 
            :headerTitle="estimated_final_target_hours_vs_final_real_hours.headerTitle"
            :headingSize="estimated_final_target_hours_vs_final_real_hours.headingSize" 
            :chartSeries="estimated_final_target_hours_vs_final_real_hours.chartSeries" 
            :lineData="estimated_final_target_hours_vs_final_real_hours.lineData"
            :chartLegend="estimated_final_target_hours_vs_final_real_hours.chartLegend"
            :chartLoaded="chartsLoaded"
        >
        </line-chart>
    </div>
</template>

<script>
import Vue from 'vue';
import SingleBarChart from '@/components/pages/project/percent_progress/common/charts/single_bar_chart.vue';
import TripleBarChart from '@/components/pages/project/percent_progress/common/charts/triple_bar_chart.vue';
import LineChart from '@/components/pages/project/percent_progress/common/charts/line_chart.vue';

export default {
    name: 'earned_value_analysis_charts_other_discipline_equipment',
    components: {
        SingleBarChart,
        TripleBarChart,
        LineChart,
    },
    props: {
        rowData: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            chartsLoaded: false,
            //Earned Value per Period based on Calculation
            earned_value_per_period_based_on_calculation: {
                headerTitle: 'general.projects.progress.earned_value_per_period_based_on_calculation.title',
                chartSeries: [
                    {
                        name: Vue.i18n.translate('table.earned_per_period'),
                        type: 'bar',
                        data: []
                    },
                ],
                chartSeriesAvailable: [
                    'earned_per_period_calculation',
                ],
                chartxAxis: [],
                chartLegend: [ 
                    {
                        name: Vue.i18n.translate('table.earned_per_period'),
                    }
                ],
                chartColor: ['#4f81bd']
            },

            //Earned Value per Period based on Status
            earned_value_per_period_based_on_status: {
                headerTitle: 'general.projects.progress.earned_value_per_period_based_on_status.title',
                chartSeries: [
                    {
                        name: Vue.i18n.translate('table.earned_per_period'),
                        type: 'bar',
                        data: []
                    },
                ],
                chartSeriesAvailable: [
                    'earned_per_period_status',
                ],
                chartxAxis: [],
                chartLegend: [ 
                    {
                        name: Vue.i18n.translate('table.earned_per_period'),
                    },
                ],
                chartColor: ['#4f81bd']
            },

            //Total Target Hours vs Real Hours
            total_target_hours_vs_real_hours: {
                headerTitle: Vue.i18n.translate('general.projects.progress.progress_current_available_chart.title'),
                headingSize: 'h4',
                chartSeries: [
                    {
                        name: Vue.i18n.translate('table.target_hours_calculation'),
                        type: 'bar',
                        data: []
                    },
                    {
                        name: Vue.i18n.translate('table.real_hours'),
                        type: 'bar',
                        data: []
                    },
                    {
                        name: Vue.i18n.translate('table.target_hours_status'),
                        type: 'bar',
                        data: []
                    },
                ],
                chartSeriesAvailable: [
                    'target_hours_calculation',
                    'real_hours',
                    'target_hours_status',
                ],
                chartxAxis: [],
                chartLegend: [
                    {
                        name: Vue.i18n.translate('table.target_hours_calculation'),
                    },
                    {
                        name: Vue.i18n.translate('table.real_hours'),
                    },
                    {
                        name: Vue.i18n.translate('table.target_hours_status'),
                    },
                ],
            },

            //Estimated Final Target Hours vs Final Real Hours
            estimated_final_target_hours_vs_final_real_hours: {
                headerTitle: Vue.i18n.translate('general.projects.progress.estimated_final_target_hours_vs_final_real_hours.title'),
                headingSize: 'h4',
                chartSeries: [
                    {
                        name: Vue.i18n.translate('table.hours_development_calculation'),
                        type: 'line',
                        data: []
                    },
                    {
                        name: Vue.i18n.translate('table.hours_development_status'),
                        type: 'line',
                        data: []
                    }
                ],
                chartSeriesAvailable: [
                    'hours_development_calculation',
                    'hours_development_status',
                ],
                lineData: [],
                chartLegend: [
                    {
                        name: Vue.i18n.translate('table.hours_development_calculation'),
                    },
                    {
                        name: Vue.i18n.translate('table.hours_development_status'),
                    },
                ],
            }
        }
    },
    mounted () {
        this.onLoadCharts();
    },
    methods: {
        onLoadCharts() {
            this.onLoadChart1();
            this.onLoadChart2();
            this.onLoadChart3();
            this.onLoadChart4();
            if (this.rowData.length > 0) {
                this.chartsLoaded = true;
            }
        },
        onLoadChart1() {
            //Earned Value per Period based on Calculation
            this.rowData.forEach((field, idx) => {
                this.earned_value_per_period_based_on_calculation.chartxAxis.push(field.step_calendar);
                var that = this;
                
                Object.keys(field).forEach(function(key) {
                    if (that.earned_value_per_period_based_on_calculation.chartSeriesAvailable[0] === key) {
                        that.earned_value_per_period_based_on_calculation.chartSeries[0].data.push(field[key]);
                    }
                });
            });
        },
        onLoadChart2() {
            //Earned Value per Period based on Status
            this.rowData.forEach((field, idx) => {
                this.earned_value_per_period_based_on_status.chartxAxis.push(field.step_calendar);
                var that = this;
                
                Object.keys(field).forEach(function(key) {
                    if (that.earned_value_per_period_based_on_status.chartSeriesAvailable[0] === key) {
                        that.earned_value_per_period_based_on_status.chartSeries[0].data.push(field[key]);
                    }
                });
            });
        },
        onLoadChart3() {
            //Total Target Hours vs Real Hours
            this.rowData.forEach((field, idx) => {
                this.total_target_hours_vs_real_hours.chartxAxis.push(field.step_calendar);
                var that = this;
                
                Object.keys(field).forEach(function(key) {
                    if (that.total_target_hours_vs_real_hours.chartSeriesAvailable[0] === key) {
                        that.total_target_hours_vs_real_hours.chartSeries[0].data.push(field[key]);
                    }

                    if (that.total_target_hours_vs_real_hours.chartSeriesAvailable[1] === key) {
                        that.total_target_hours_vs_real_hours.chartSeries[1].data.push(field[key]);
                    }

                    if (that.total_target_hours_vs_real_hours.chartSeriesAvailable[2] === key) {
                        that.total_target_hours_vs_real_hours.chartSeries[2].data.push(field[key]);
                    }
                });
            });
        },
        onLoadChart4() {
            //Estimated Final Target Hours vs Final Real Hours
            this.rowData.forEach((field, idx) => {
                this.estimated_final_target_hours_vs_final_real_hours.lineData.push(field.step_calendar);

                var that = this;
                
                Object.keys(field).forEach(function(key) {
                    if (that.estimated_final_target_hours_vs_final_real_hours.chartSeriesAvailable[0] === key) {
                        that.estimated_final_target_hours_vs_final_real_hours.chartSeries[0].data.push(field[key]);
                    }

                    if (that.estimated_final_target_hours_vs_final_real_hours.chartSeriesAvailable[1] === key) {
                        that.estimated_final_target_hours_vs_final_real_hours.chartSeries[1].data.push(field[key]);
                    }
                });
            });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/percent_progress/other_discipline/equipment/earned_value_analysis/earned_value_analysis_charts_other_discipline_equipment.vue